'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.createGridLoadingData = exports.isRowMockData = exports.lockColumnsPin = undefined;

var _lodash = require('lodash.get');

var _lodash2 = _interopRequireDefault(_lodash);

var _lodash3 = require('lodash.keyby');

var _lodash4 = _interopRequireDefault(_lodash3);

var _lodash5 = require('lodash.clonedeep');

var _lodash6 = _interopRequireDefault(_lodash5);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var loadingSubKey = 'loadingMock';

var isRowMockData = function isRowMockData(data) {
    return data && ('' + data.gridRowId).includes(loadingSubKey);
};

var createGridLoadingData = function createGridLoadingData(dataLength) {
    var array = [];

    for (var i = 0; i < dataLength; i += 1) {
        array.push({ gridRowId: '' + loadingSubKey + i });
    }

    return array;
};

var lockColumnsPin = exports.lockColumnsPin = function lockColumnsPin(columnDefinitions, columnState) {
    var newColumnState = (0, _lodash6.default)(columnState);
    var columnDefinitionMap = (0, _lodash4.default)(columnDefinitions, 'colId');

    newColumnState.forEach(function (item, index) {
        if ((0, _lodash2.default)(columnDefinitionMap[item.colId], 'lockPosition') && !item.pinned) {
            newColumnState[index].pinned = columnDefinitionMap[item.colId].lockPosition;
        }
    });

    return newColumnState;
};

exports.isRowMockData = isRowMockData;
exports.createGridLoadingData = createGridLoadingData;